module.exports = __webpack_public_path__ + "static/img/serverShop7.9547138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/serverShop7.png
// module id = ik4r
// module chunks = 0